import React, { useCallback, useEffect, useMemo, useState } from "react";
import SearchBootstrapTable from "app/Components/BootstrapTable/SearchBootstrapTable";
import { Link } from "react-router-dom";
import { FiEye } from "react-icons/fi";

import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit";
import BootstrapTable from "react-bootstrap-table-next";
import { ACTIVE_MODULE } from "app/_constants/constant";
import BackBtn from "app/Components/CommanComponents/BackBtn";

import { useForm } from "app/_helpers/hooks";
import CustomTooltip from "app/Components/CommanComponents/CustomTooltip";
import { getAllVFLHistory } from "app/_services/ehs/VFLService";
import {
  DDMMYYYYFormat,
  DDMMYYYYHHMMAFormat,
  isBetween,
  YYYYMMDDFormat,
} from "app/_helpers/dateHelper";
import {
  checkVflStatusFilter,
  getVFLStatusClass,
  incidentFilterFields,
  VFL_STATUS,
  VFL_STATUS_COLUMN,
  VFL_STATUS_VIEW,
} from "./CONSTANTS";
import { validateRowFilter } from "../IncidentManagement/CONSTANTS";
import VFLFilters from "./component/VFLFilters";
import FilterBtn from "app/Components/CommanComponents/FilterBtn";
import paginationFactory from "react-bootstrap-table2-paginator";
import { formatDDMMYYYYbyYYYYMMDD, paginationOptionsObj } from "app/_helpers/helper";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import MainBreadcrumb from "app/views/custom/components/MainBreadcrumb";
import NetZeroLoader from "app/views/custom/components/Loader/NetZeroLoader";

const { SearchBar } = Search;

function MyApprovalHistoryVFL({
  match: {
    params: { siteId },
  },
}) {
  const [tab, setTab] = useState(0);
  const [incidents, setIncidents] = useState([]);
  const [incidentsFilter, setIncidentsFilter] = useState([]);
  const [filterForm, onChangeFilter, setFilterForm] = useForm({}, incidentFilterFields);
  const [VFLFilter, setVFLFilter] = useState([]);
  const [showFilter, setShowFilter] = useState(false);
  const [loading, setLoading] = useState(true);

  const sortableColumn = useMemo(
    () => [
      {
        dataField: "sid",
        text: "S.No.",
        sort: true,
      },
      {
        dataField: "vflId",
        text: "VFL Id",
        sort: true,
        formatter: (vflId, row) => (
          <OverlayTrigger
            placement="top"
            overlay={<Tooltip id="tooltip-top">View</Tooltip>}
          >
            <Link
              className="icons text-cyanBlue"
              to={
                row.vflStatus === VFL_STATUS.completed
                  ? "/health-safety-and-environment/vfl/completion/view/" + row.id
                  : "/health-safety-and-environment/vfl/view/" + row.id
              }
            >
              {vflId}
            </Link>
          </OverlayTrigger>
        ),
      },
      // {
      //   dataField: "vflScheduledDateTimeView",
      //   text: "VFL Scheduled Date",
      //   sort: true,
      // },
      {
        dataField: "mineName",
        text: "Location Name",
        sort: true,
      },
      {
        dataField: "siteData.siteId",
        text: "Location Code",
        sort: true,
        formatter: (ehsSite, row) => {
          return (
            <span title={row?.siteData ? row?.siteData?.name : ""}>
              {row?.siteData ? row?.siteData?.siteId : ""}
            </span>
          );
        },
      },
      {
        dataField: "vflExecutiveName",
        text: "VFL Executive",
        sort: true,
      },
      {
        dataField: "ehs_area_of_operations.name",
        text: "Area",
        sort: true,
      },
      {
        dataField: "departmentId",
        text: "Department",
        sort: true,
      },
      {
        dataField: "contractorInvolved",
        text: "Contractor",
        sort: true,
        formatter: (contractorInvolved) => {
          return contractorInvolved ? "Yes" : "No";
        },
      },
      {
        dataField: "vflStatusView",
        text: "Status",
        sort: true,
        formatter: (status, row) => {
          return VFL_STATUS_COLUMN(row?.vflStatus, row);
        },
      },
      {
        dataField: "createdAt",
        text: "Time Stamp",
        sort: true,
        formatter: (createdAt, row) => {
          return DDMMYYYYHHMMAFormat(createdAt);
        },
      },
      {
        dataField: "create",
        text: "Action",
        formatter: (rowContent, row) => {
          return (
            <div className="actionIconsGroup">
              <CustomTooltip tooltip={"View"}>
                <Link
                  to={"/health-safety-and-environment/vfl/view/" + row.id}
                  className="icons text-cyanBlue"
                >
                  <FiEye />
                </Link>
              </CustomTooltip>
            </div>
          );
        },
      },
    ],
    []
  );

  const onReset = useCallback(() => {
    setFilterForm({});
  }, [setFilterForm]);

  /**************** useEffect *************/
  useEffect(() => {
    // getAllVFLHistory(siteId ? `filter[siteId]=${siteId}` : "").then((response) => {
    //   if (!response?.data) return;
    //   setIncidents(response.data);
    // });

    const fetchData = async () => {
      try {
        const response = await getAllVFLHistory(siteId ? `filter[siteId]=${siteId}` : "");
        if (!response?.data) {
          // Handle the case where data is not received
          setLoading(false);
          return;
        }
        setIncidents(response.data);
        setLoading(false);
      } catch (error) {
        console.error("Error fetching data:", error);
        // Handle error as needed, e.g., show an error message
        setLoading(false);
      }
    };
    fetchData();
  }, [siteId]);

  useEffect(() => {
    let data = [];

    if (tab === 1) {
      data =
        incidents?.safetyOfficer?.map((d, i) => ({
          ...d,
          sid: i + 1,
          vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
          mineName: d?.siteData?.name,
          vflStatusView: !d?.executiveReturn
            ? VFL_STATUS_VIEW[d?.vflStatus]
            : VFL_STATUS_VIEW?.ExecutiveReturn,
          vflExecutiveName: d?.vflOfficerData
            ? `${d?.vflOfficerData?.firstName} ${d?.vflOfficerData?.lastName}`
            : "",
        })) || [];
    }
    if (tab === 2) {
      data =
        incidents?.minesManager?.map((d, i) => ({
          ...d,
          sid: i + 1,
          vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
          mineName: d?.siteData?.name,
          vflStatusView: !d?.executiveReturn
            ? VFL_STATUS_VIEW[d?.vflStatus]
            : VFL_STATUS_VIEW?.ExecutiveReturn,
          vflExecutiveName: d?.vflOfficerData
            ? `${d?.vflOfficerData?.firstName} ${d?.vflOfficerData?.lastName}`
            : "",
        })) || [];
    }
    if (tab === 3) {
      data =
        incidents?.vflOfficer?.map((d, i) => ({
          ...d,
          sid: i + 1,
          vflScheduledDateTimeView: DDMMYYYYFormat(d.vflScheduledDateTime),
          mineName: d?.siteData?.name,
          vflStatusView: !d?.executiveReturn
            ? VFL_STATUS_VIEW[d?.vflStatus]
            : VFL_STATUS_VIEW?.ExecutiveReturn,
          vflExecutiveName: d?.vflOfficerData
            ? `${d?.vflOfficerData?.firstName} ${d?.vflOfficerData?.lastName}`
            : "",
        })) || [];
    }

    // let result = data.filter((row) => validateRowFilter(filterForm, row));

    setIncidentsFilter(data);
  }, [incidents?.vflOfficer, incidents?.minesManager, incidents?.safetyOfficer, tab]);

  useEffect(() => {
    setTab(
      incidents?.safetyOfficer?.length
        ? 1
        : incidents?.minesManager?.length
        ? 2
        : incidents?.vflOfficer?.length
        ? 3
        : 0
    );
  }, [
    incidents?.vflOfficer?.length,
    incidents?.minesManager?.length,
    incidents?.reported?.length,
    incidents?.safetyOfficer?.length,
  ]);

  useEffect(() => {
    if (filterForm.hasOwnProperty("contractorInvolved")) {
      if (filterForm.contractorInvolved === "") filterForm.contractorInvolved = 0;
    }
    setVFLFilter(
      incidentsFilter?.filter?.((data) => {
        let flag = true;
        if (filterForm?.startDate && filterForm?.endDate) {
          flag = isBetween(
            data.vflScheduledDateTime,
            YYYYMMDDFormat(filterForm.startDate),
            YYYYMMDDFormat(filterForm.endDate)
          );
        }

        if (filterForm?.vflStatus && flag) {
          flag = checkVflStatusFilter(filterForm?.vflStatus, data);
        }

        if (flag) flag = validateRowFilter(filterForm, data);
        return flag;
      })
    );
  }, [filterForm, incidentsFilter]);

  const tableToolbarBeforeView = () =>
    showFilter && (
      <VFLFilters
        fields={incidentFilterFields}
        setForm={setFilterForm}
        form={filterForm}
        onChange={onChangeFilter}
        onReset={onReset}
      />
    );

  return (
    <>
      <MainBreadcrumb
        routeSegments={[
          { name: "Health Safety And Environment", path: "#" },
          {
            name: "Visible Felt Leadership",
            path: "/health-safety-and-environment/vfl",
          },
          { name: "My Approval History" },
        ]}
        module={ACTIVE_MODULE.vfl}
      />
      <div className="card p-3">
        <div className="simple-card-title cardCustomHeader">
          <h3 class="text-capitalize mb-1">My Approval History</h3>
          <FilterBtn setShowFilter={setShowFilter} />
          <BackBtn url={"/health-safety-and-environment/vfl"} />
        </div>

        <div className="healthSafetyEnvironmentWrapper EHS_module_tabber mb-3">
          <div className="hseMenuLinks card">
            {incidents?.safetyOfficer?.length > 0 && (
              <a
                href
                onClick={() => setTab(1)}
                className={`pointer${tab === 1 ? " active" : ""}`}
              >
                Safety Officer
              </a>
            )}
            {incidents?.minesManager?.length > 0 && (
              <a
                href
                onClick={() => setTab(2)}
                className={`pointer${tab === 2 ? " active" : ""}`}
              >
                Mines Manager
              </a>
            )}
            {incidents?.vflOfficer?.length > 0 && (
              <a
                href
                onClick={() => setTab(3)}
                className={`pointer${tab === 3 ? " active" : ""}`}
              >
                VFL Executive
              </a>
            )}
          </div>
        </div>

        {/* <ToolkitProvider
          striped
          keyField="id"
          data={VFLFilter} */}
        {/* columns={sortableColumn}
          // search={{
          //   defaultSearch: filterStatus?.manageIncidentSearch,
          // }}
        > */}
        {/* {(props) => (
            <> */}
        {/* {showFilter && (
                <VFLFilters
                  fields={incidentFilterFields}
                  setForm={setFilterForm}
                  form={filterForm}
                  onChange={onChangeFilter}
                  onReset={onReset}
                />
              )} */}
        {/* <div className="d-flex align-items-center justify-content-between pb-3"> */}
        {/* <SearchBar {...props.searchProps} className="mb-0" /> */}
        {/* <div className="btn-toolbar"></div>
              </div> */}

        {/* <div className="material-master-table incidentTable"> */}
        {/* <BootstrapTable {...props.baseProps} bootstrap4 noDataIndication={"Table is empty"} pagination={paginationFactory({ ...paginationOptionsObj, totalSize: Array.isArray(VFLFilter) ? VFLFilter.length : 0, })} /> */}
        {!loading ? (
          <SearchBootstrapTable
            searchKey={"myApprovalHistoryVFLDesktopSearch"}
            data={VFLFilter}
            columns={sortableColumn}
            tableBeforeSearch={tableToolbarBeforeView}
            tableKey="myApprovalHistoryVFL"
            defaultHideColumn={["mineName"]}
          />
        ) : (
          <NetZeroLoader />
        )}

        {/* </div>
            </>
          )}
        </ToolkitProvider> */}
      </div>
    </>
  );
}

export default MyApprovalHistoryVFL;
